<template>
  <div class="col-sm-12 col-md">
    <b-form-group :label="computedLabel">
      <b-form-file
        id="input-employment-information"
        v-model="model"
        :state="errors ? false : null"
        :placeholder="computedPlaceholder"
        @change="inputChange"
        @input="onInput"
        :required="required"
        :browse-text="$t('Browse')"
        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
        multiple
        :disabled="disabled"
      />
      <div v-if="errors" class="invalid-feedback d-block">
        {{ errors }}
      </div>

      <UploadedFilesList 
        :files="existingFiles" 
        :deleted-files="deletedFiles"
        @remove="onRemoveExistingFile"
        @mark-for-deletion="onMarkFileForDeletion"
        @restore="onRestoreFile"
      />
    </b-form-group>
  </div>
</template>

<script>
import BaseInputMixin from "../../../../mixins/profileInputMixin";
import {mapState} from "vuex";
import UploadedFilesList from "./UploadedFilesList.vue";
import identificationFilesMixin from "../../../../mixins/identificationFilesMixin";

export default {
  name: "EmploymentInformation",
  mixins: [BaseInputMixin('employment_information', 'identityVerification', 'identityVerificationFieldOnInput'), identificationFilesMixin('employment_information')],
  components: { UploadedFilesList },
  data() {
    return {
      defaultLabel: this.$t("Employment Information"),
      defaultPlaceholder: this.$t("Choose files...")
    }
  },
  computed: {
    ...mapState({})
  }
}
</script>

<style scoped>

</style>
